import { useTranslation } from "react-i18next";
import {
  getDefaultBookkeepingAccountForPaymentMethod,
  getEffectiveBookkeepingMapping,
} from "@KassaroAB/shared/utils/bookkeepingDefaultAccounts";
import type { PaymentMethodNetsMock } from "@KassaroAB/shared/types/paymentMethods/paymentMethod";
import { FieldGroupPaymentMethodFields } from "../paymentMethodFieldGroup";
import { usePaymentMethodForm } from "../paymentMethodFormHook";
import {
  PaymentMethodFormContainer,
  type PaymentMethodFormProps,
} from "./PaymentMethodFormContainer";
import { basePaymentMethodValues } from "./basePaymentMethodValues";

export const PaymentMethodBaseForm = ({
  formId,
  store,
  paymentMethod,
  savedTick,
  onSubmit,
  onDirtyChange,
}: PaymentMethodFormProps<Omit<PaymentMethodNetsMock, "id">>) => {
  const { t } = useTranslation();
  const mergedAccounts = getEffectiveBookkeepingMapping(
    store.country,
    store.bookkeepingDefaultAccounts,
  );
  const form = usePaymentMethodForm({
    defaultValues: basePaymentMethodValues(paymentMethod),
    onSubmit: ({ value }) => onSubmit(value),
  });

  return (
    <PaymentMethodFormContainer
      formId={formId}
      form={form}
      savedTick={savedTick}
      onDirtyChange={onDirtyChange}
    >
      <FieldGroupPaymentMethodFields
        form={form}
        fields={{
          name: "name",
          type: "type",
          bookkeepingAccountId: "bookkeepingAccountId",
          color: "color",
        }}
        defaultAccountNumber={getDefaultBookkeepingAccountForPaymentMethod(
          mergedAccounts,
          { type: paymentMethod.type },
        )}
        t={t}
      />
    </PaymentMethodFormContainer>
  );
};
